<template>
  <div v-if="open" class="modal-overlay" @click.self="onCancel">
    <div class="modal-card">
      <template v-if="step === 'confirm'">
        <h3>Confirm DSA Pass Redemption</h3>
        <p>
          You are about to redeem one quota from your DSA pass for
          <b>{{ subjectName || 'this subject' }}</b>.
          Once redeemed, this quota will be consumed and cannot be restored.
          Would you like to continue?
        </p>
        <div class="actions">
          <button type="button" class="btn btn-outline" :disabled="busy" @click="onCancel">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="busy" @click="$emit('confirm')">
            {{ busy ? 'Redeeming…' : 'Confirm' }}
          </button>
        </div>
      </template>
      <template v-else>
        <h3>Cannot Complete Redemption</h3>
        <p>
          You do not have an available DSA pass quota.
          Please purchase a new DSA pass to gain additional exam attempts.
        </p>
        <div class="actions">
          <button type="button" class="btn btn-outline" @click="onCancel">Cancel</button>
          <button type="button" class="btn btn-primary" @click="$emit('purchase')">Purchase DSA Pass</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedeemPassModal',
  props: {
    open: { type: Boolean, default: false },
    /** 'confirm' | 'no_pass' */
    step: { type: String, default: 'confirm' },
    subjectName: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },
  methods: {
    onCancel() {
      if (this.busy) return
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;z-index:1000;padding:16px}
.modal-card{background:#fff;border-radius:14px;padding:24px;max-width:440px;width:100%;box-shadow:0 12px 40px rgba(15,23,42,.16)}
.modal-card h3{font-size:18px;font-weight:700;margin:0 0 8px}
.modal-card p{font-size:14px;color:var(--muted,#64748b);margin:0 0 20px;line-height:1.55}
.modal-card p b{color:var(--ink,#1a202c);font-weight:600}
.modal-card .actions{display:flex;justify-content:flex-end;gap:10px;flex-wrap:wrap}
</style>
